export default __webpack_public_path__ + "static/media/dai.65596d33.png";